import script from "./RejectNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./RejectNotification.vue?vue&type=script&setup=true&lang=js"

import "./RejectNotification.vue?vue&type=style&index=0&id=23c4347d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c4347d"]])

export default __exports__